import clsx from "clsx";
import { AutocompleteInputRoot } from "./AutocompleteInput.styles";
import { SelectProps } from "../../Select/Select.types";
import { TextFieldProps } from "../../TextField/TextField.types";

export interface AutocompleteInputProps extends Omit<TextFieldProps, "variant"> {
    className?: string;
    style?: React.CSSProperties;
    size?: SelectProps<string, false>["size"];
}

function AutocompleteInput({ className, size, ...rest }: AutocompleteInputProps) {
    return <AutocompleteInputRoot className={clsx("autocomplete-input", size?.capitalize(), className)} variant="outlined" {...rest} />;
}

export default AutocompleteInput;
